<template>
    <div class="import-tool">
        <Modal
            v-model="visible"
            title="批量导入"
            :closable="true"
            :mask-closable="false"
            width="530"
            :footer-hide="true"
            class="my-modal top import-tool-modal2"
        >
            <div class="ivu-modal-footer">
                <div class="text1">导入进度</div>
                <div class="btn-box">
                    <tooltip :txtInfo="curData.fileName" v-if="curData.fileName && curData.fileName.length > 20"></tooltip>
                    <span v-else>{{ curData.fileName }}</span>
                    <Upload
                        ref="upload"
                        :show-upload-list="false"
                        class="upload-btn"
                        :format="fileFormat"
                        :max-size="2048"
                        :before-upload="handleFormatError"
                        accept=".xls,.xlsx"
                        action="/"
                    >
                        <Button type="primary" ghost v-if="!curData.fileName">上传Excel</Button>
                        <Button type="primary" ghost v-if="curData.fileName && progress == 0">重传Excel</Button>
                        <Button type="primary" v-if="curData.fileName && progress == 100">继续上传Excel</Button>
                    </Upload>
                    <Button type="primary" @click="startUpload" v-if="curData.fileName && progress != 100" style="width: 105px"
                        >确定导入</Button
                    >
                </div>
            </div>
            <Progress :percent="progress" status="active" />

            <div class="ivu-modal-footer footer">
                <div class="btn-box">
                    <Button type="primary" @click="downloadTemplate([])" ghost>下载导入模板</Button>
                </div>
            </div>
        </Modal>

        <!-- 导入进度 -->
        <div class="import-small-list" v-if="visibleSmall">
            <div class="import-small" v-for="(bean, i) in list" :key="i" v-show="bean.batchNo != curData.batchNo">
                <div class="top-box">
                    <tooltip :txtInfo="bean.fileName" v-if="bean.fileName.length > 20"></tooltip>
                    <div v-else>{{ bean.fileName }}</div>
                    <div class="btn-box">
                        <div class="top-btn" v-if="bean.progress == 100">关闭</div>
                    </div>
                </div>
                <Progress :percent="bean.progress" status="active" />
            </div>
        </div>
    </div>
</template>
<script>
import tooltip from '@/components/commons/tooltip';
import filter from '@/api/filter';

export default {
    components: {
        tooltip
    },
    props: {
        // 1:人员清单、2:保全信息、3:保全信息重新上传
        type: {
            default: null,
            type: Number
        }
    },
    data() {
        return {
            filter,
            fileFormat: ['xls', 'xlsx'],
            visible: false,
            visibleSmall: false,
            data: {},
            file: {},
            progress: 0,
            policyNo: '', //保单号
            curData: {},
            list: [], //进行中任务列表
            formData: {}
        };
    },
    activated() {
        this.visibleSmall = true;
    },
    deactivated() {
        this.visible = false;
        this.visibleSmall = false;
    },
    methods: {
        open(policyNo, row) {
            this.policyNo = policyNo;
            this.curData = {};
            this.file = {};
            this.progress = 0;
            this.visible = true;

            if (this.type == 3) {
                this.formData = {
                    id: row.id,
                    billNo: row.billNo,
                    type: row.type,
                    fee: row.fee,
                    startTime: row.startTime,
                    id: row.id
                };
            }
        },
        // 下载
        downloadTemplate(data) {
            this.$http({
                url: this.type == 1? '/buz/grouppolicy/enter/insures/export':'/buz/grouppolicy/enter/endorsement/insures/export',
                type: 'POST',
                responseType: 'blob',
                data
            }).then(res => {
                this.$units.daochu(res);
            });
        },

        // 文件文件格式验证失败时的钩子，返回字段为 file, fileList
        handleFormatError(file) {
            const format = file.name.split('\.')[1];
            if (!this.fileFormat.includes(format)) {
                this.$notice.msg('请上传' + this.fileFormat.join(',') + '格式的文件');
                return false;
            }
            this.curData = {
                fileName: file.name.split('\.')[0]
            };
            this.file = file;
            this.progress = 0;
            return false;
        },
        // 开始上传
        startUpload() {
            if (this.file.loading) {
                return;
            }
            const close = this.$notice.loading('文件解析校验中');
            this.file.loading = true;
            let formData = new FormData();
            formData.append('file', this.file);
            this.$http({
                url: this.type == 1? '/buz/grouppolicy/enter/insures/import':'/buz/grouppolicy/enter/endorsement/insures/import',
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                data: formData
            })
                .then(res => {
                    this.file.loading = false;
                    this.progress = 100;
                    // 人员清单上传
                    if (this.type == 1) {
                        close();
                        this.addData(res.data);
                    } else if (this.type == 2) {
                        // 保全信息上传
                        close();
                        const successNum = res.data.successList && res.data.successList.length;
                        const errorNum = res.data.failList && res.data.failList.length;
                        let text = `系统已成功导入${successNum}条数据`;
                        if (errorNum) {
                            text = text + `，存在${errorNum}条数据未导入`;
                            this.downloadTemplate(res.data.failList);
                            this.$notice.error(text);
                        } else {
                            this.$notice.success(text);
                            this.visible = false;
                        }
                        this.$emit('success-data', res.data);
                    } else if (this.type == 3) {
                        // 保全信息重新上传
                        close();
                        const successNum = res.data.successList && res.data.successList.length;
                        const errorNum = res.data.failList && res.data.failList.length;
                        let text = `系统已成功导入${successNum}条数据`;
                        if (errorNum) {
                            text = text + `，存在${errorNum}条数据未导入`;
                            this.downloadTemplate(res.data.failList);
                            this.$notice.error(text);
                            return
                        }
                        const formData = JSON.parse(JSON.stringify(this.formData));
                        formData.startTime = formData.startTime ? filter.filterTime(formData.startTime, 'YYYY-MM-DD') : '';
                        const data = {
                            endorsementBos: {
                                ...formData,
                                insureList: res.data.successList
                            },
                            policyNo: this.policyNo
                        };
                        this.$http({
                            url: '/buz/grouppolicy/enter/endorsement/saveOrUpdate',
                            type: 'POST',
                            data
                        }).then(res => {
                            this.visible = false;
                            this.$emit('upload-success');
                        });
                    }
                })
                .catch(e => {
                    close();
                    this.file.loading = false;
                });
        },
        addData(insureList) {
            const successNum = insureList.successList && insureList.successList.length;
            const errorNum = insureList.failList && insureList.failList.length;
            let text = `系统已成功导入${successNum}条数据`;
            if (errorNum) {
                text = text + `，存在${errorNum}条数据未导入`;
                this.downloadTemplate(insureList.failList);
                this.$notice.error(text);
            } else {
                this.$notice.success(text);
            }

            this.$http({
                url: '/buz/grouppolicy/enter/insures/saveOrUpdate',
                type: 'POST',
                data: {
                    insureList: insureList.successList,
                    policyNo: this.policyNo
                }
            }).then(res => {
                this.$emit('upload-success');
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.import-tool-modal2 /deep/ {
    .top-btn {
        position: absolute;
        right: 0;
        top: -30px;
        background: #fff;
        z-index: 1;
        padding-right: 20px;
        color: #236dff;
        cursor: pointer;
        &.ivu-icon-md-close {
            font-size: 18px;
            color: #8a9095;
        }
    }
    .ivu-modal-header-inner {
        font-size: 14px;
        font-weight: bold;
        color: #3c464f;
    }
    .ivu-modal-close {
        top: 4px;
        .ivu-icon-ios-close {
            font-size: 30px;
            color: #a8adb7;
        }
    }
    .ivu-modal-header {
        padding: 0 20px;
        height: 40px;
        line-height: 40px;
    }
    .ivu-modal-body {
        padding-top: 30px;
        padding-bottom: 30px;
        overflow: initial;
        position: relative;
    }
    .ivu-progress {
        margin-top: 10px;
        margin-bottom: 5px;
    }
    .progress-text {
        margin-bottom: 10px;
        visibility: hidden;
        &.show {
            visibility: visible;
        }
        span {
            margin-right: 20px;
        }
    }
    .ivu-modal-footer {
        border-top: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0;
        position: static;
        .iconfont {
            font-size: 14px;
            margin-right: 4px;
        }
        .ivu-btn {
            width: auto;
        }
    }
    .footer {
        margin-top: 10px;
    }
    .btn-box {
        display: flex;
        align-items: center;
        button {
            margin-left: 10px;
            &:first-child {
                margin-left: 0;
            }
        }
        .ivu-tooltip {
            display: inline-flex;
            width: 200px !important;
        }
    }
    .ivu-progress-show-info .ivu-progress-outer {
        padding-right: 40px;
        margin-right: -40px;
    }
}
.import-small-list {
    position: fixed;
    right: 10px;
    bottom: 20px;
    z-index: 1000;
}
.import-small {
    border-radius: 5px;
    background-color: #fff;
    box-shadow: 0 0 6px -2px rgb(0, 0, 0);
    width: 300px;
    padding: 15px;
    margin-top: 15px;
    .top-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .tips-content {
            width: calc(100% - 100px);
        }
        .btn-box {
            display: flex;
            .top-btn {
                margin-left: 15px;
                color: #236dff;
                cursor: pointer;
            }
        }
    }
    /deep/ {
        .ivu-progress-show-info .ivu-progress-outer {
            padding-right: 40px;
            margin-right: -40px;
        }
    }
    .progress-text {
        span {
            margin-right: 15px;
        }
    }
}
</style>
